/** actorId the pipeline writes on discrepancy events; also the column default. */
export const SYSTEM_ACTOR_ID = "system";

/** A PENDING event on a missing e-Manifest row is a follow-up on the missing manifest, not a correction request. */
export function isMissingEManifestPendingEvent(event: { field: string }): boolean {
  return event.field === "eManifestMissing";
}

/**
 * Whether a PENDING event was filed by the pipeline as "needs correction in e-Manifest".
 * A system PENDING on a missing e-Manifest is a missing e-Manifest follow-up instead.
 */
export function isSystemFiledPendingEvent(event: { actorId: string; field: string }): boolean {
  return event.actorId === SYSTEM_ACTOR_ID && !isMissingEManifestPendingEvent(event);
}
